import { API_CALL_STATUS } from '../../../reducers/status';
import axios from 'axios';
import { setAhocReferenceDataValue } from '../../../actions/allsureHomeClaim/referenceData';
import { getDocumentsArray } from '../../../selectors/allsureHomeClaim/uploadDocuments';
import { getBasicDetailsForm } from '../../../selectors/allsureHomeClaim/basicDetails';
import {  getAhocReferenceNumber } from '../../../selectors/allsureHomeClaim/referenceData';
import { navigateToSuccessPage } from '../../../actions/allsureHomeClaim/routing';
import { getClaimName } from '../../../selectors/allsureHomeClaim/routing';
import { submitPolicy } from '../../../actions/allsureHomeClaim/policyRequest';

export const uploadDocumentsService = (store, next, action) => {
    const state = store.getState();
    (async () => {
        try {
            store.dispatch(setAhocReferenceDataValue({ type:"apiStatus", value:API_CALL_STATUS.PENDING }));
            const documentsArray = getDocumentsArray(state);
            const { fullName, mobileNumber, email , policyNumber} = getBasicDetailsForm(state);
            const productLabel = getClaimName(state);
            const subject = `Web: ${productLabel} : ${fullName?.value} - REF: ${policyNumber.value}`;
            const files = await documentsArray.reduce(async (f, x) => {
                return f.then(async (last) => {
                    let hasError = false;
                    if (x.file !== null) {
                        const formData = new FormData();
                        formData.append('files', x.file);
                        formData.append('subject', subject);
                        formData.append('contactNumber', mobileNumber.value);
                        formData.append('email', 'ALLSURE_CLAIM_DOCUMENT_MAIL');
                        const executeApiWithDelay = async () => {
                            return new Promise ((resolve)=>{
                                setTimeout(async () =>{                               
                                await uploadDocuments(formData)
                                    .then((response) => {
                                        if (response && response?.status === 200) {
                                            hasError = false;
                                        } else {
                                            hasError = true;
                                        }
                                    })
                                    .catch((error) => {
                                        throw error;
                                    })
                                return resolve()
                                }
                        ,500);
                            }
                            )
                        };
                        await executeApiWithDelay();
                    }

                    last.push({ key: x.fileName, hasError });

                    return last;
                });
            }, Promise.resolve([]));
            if (files.some((x) => x.hasError)) {
                store.dispatch(setAhocReferenceDataValue({type:"apiStatus",value:API_CALL_STATUS.FAILURE}));
            } else {
                store.dispatch(setAhocReferenceDataValue({type:"apiStatus",value:API_CALL_STATUS.SUCCESS}));
                store.dispatch(submitPolicy());
            }
        } catch (e) {
            store.dispatch(setAhocReferenceDataValue({type:"apiStatus",value:API_CALL_STATUS.FAILURE}));
        }
    })();
    return next(action);
};

const uploadDocuments = async (payload) => {
    const url = 'om-api/bw-upload-document-email/documents/kyc ';
    try {
        const response = await axios.post(url, payload, {
            headers: {
                'Content-Type': 'multipart/form-data',
                'x-api-key': 'test-api-key',
            },
        });
        return response;
    } catch (error) {
        return null;
    }
};
